<template>
  <div
    id="confirmModal"
    ref="confirmModalRef"
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ title }}
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="cancel"
          />
        </div>
        <div class="modal-body">
          <p v-html="message" />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="cancel"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="confirm"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Modal from "bootstrap/js/dist/modal";

const title = ref("");
const message = ref("");
const confirmModalRef = ref<HTMLElement | null>(null);

let modal: Modal | null = null;

// Promise resolve/reject 저장용
let resolver: ((value: boolean) => void) | null = null;

// 부모에서 호출하는 함수
function showConfirmModal(newTitle: string, newMsg: string) {
  title.value = newTitle;
  message.value = newMsg;

  if (!modal && confirmModalRef.value) {
    modal = new Modal(confirmModalRef.value, { backdrop: "static" });
  }

  modal?.show();

  // Promise 반환
  return new Promise<boolean>((resolve) => {
    resolver = resolve;
  });
}

function confirm() {
  modal?.hide();
  resolver?.(true);  // 확인
}

function cancel() {
  modal?.hide();
  resolver?.(false); // 취소
}

// 외부에서 showConfirmModal 호출 가능하도록
defineExpose({
  showConfirmModal
});
</script>
